import React from "react";
import store from '../../store/store'
import { InputItem,Button,Toast } from 'antd-mobile';
import "./monitoring.scss"
import {monitorLists,monitorList} from "../../api/index"
import Buttons from '../../components/buttons/button'
export default class Monitoring extends React.Component{
    constructor(props){
        super(props);
        this.state={
            btns:[],
            activePart:"",
            numData:{
                jjdd:0,
                nfjj:0,
                nfdd:0,
                cqdd:0,
                zcdd:0,
                drfh:0,
                total:0,
                finish:0
            }
        }
        
    }
    async btnBack(){
        let res = await monitorLists({ pgType:1})
        if(res.code==0){
            res.data.forEach(i=>{
                i.id =  i.id.toString() 
                i.name=i.deptName;
                i.val=i.deptId||0;
            })
            this.setState({
                btns:res.data,
                activePart:res.data[0].deptId
            },()=>{
                this.monitorList();
            })
        }else{
            Toast.fail(res.msg,3)
        }
    }
    async monitorList(){
        Toast.loading("加载中...",5000)
        let data = {
            deptId:this.state.activePart,
            type:1,
            // keyWord:this.keyWord,
            outTime:72,
            pgType:1,
            pageNumber:1,
            pageSize:10
        }
        await monitorList(data).then(res=>{
            if(res.code === 0){
                Toast.hide()
                this.setState({
                    numData:{
                        jjdd:res.data.jjCount,
                        nfjj:res.data.nfjjCount,
                        nfdd:res.data.nfCount,
                        cqdd:res.data.cqCount,
                        zcdd:res.data.zcCount,
                        drfh:res.data.fhCount,
                        total:res.data.totalXd,
                        finish:res.data.totalWj
                    }
                })
                
            }else{
                Toast.hide()
                Toast.fail(res.msg,3)
            }

        }).catch(Err=>{
            Toast.hide()
            console.log(Err)
        })
       


    }
    changePart(deptId){
        this.setState({
            activePart:deptId
        },()=>{
            this.monitorList();
        })
    }
    render(){
        
        return(
            <div className="monitoring">
                <div className="type">
                    <ul>
                        {
                            this.state.btns.map((s)=>{
                                return <li onClick={()=>{this.changePart(s.deptId)}} key={s.deptId} className={this.state.activePart==s.deptId?"activePart":""}>{s.deptName}</li>
                            })
                        }
                        
                    </ul>
                </div>
                <div className="content">
                    <div>
                        <p>
                            {this.state.numData.jjdd}
                        </p>
                        <span>
                            加急订单
                        </span>
                    </div>
                    <div>
                        <p>
                            {this.state.numData.nfjj}
                        </p>
                        <span>
                            内返加急
                        </span>
                    </div>
                    <div>
                        <p>
                            {this.state.numData.nfdd}
                        </p>
                        <span>
                            内返订单
                        </span>
                    </div>
                    <div>
                        <p className="cq">
                            {this.state.numData.cqdd}
                        </p>
                        <span>
                            超期订单
                        </span>
                    </div>
                    <div>
                        <p className="zc">
                            {this.state.numData.zcdd}
                        </p>
                        <span>
                            正常订单
                        </span>
                    </div>
                    <div>
                        <p className="dr">
                            {this.state.numData.drfh}
                        </p>
                        <span>
                            当日发货
                        </span>
                    </div>
                </div>
                <div className="textnum">
                      <span>当日完成：{this.state.numData.finish}本</span>
                      <span>当前总量：{this.state.numData.total}本</span>
                </div>
            </div>
            
        )
    }
    componentDidMount(){
        this.btnBack();
    }
}

